<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Manage Ticket Categories</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <div class="modal-card-body has-text-centered">

          <article 
            v-if="categories.length == 0" 
            class="message is-info is-fullwidth">
            <div class="message-body">
              There are no categories
            </div>
          </article>

          <!-- existing categories -->
          <div class="panel" v-if="categories.length > 0">
            <a class="panel-block" 
              v-for="category in categories"
              :key="category.id">
              <div class="row-justified is-fullwidth">

                <div v-if="category.id != editingCategoryId">
                  {{ category.category }}
                </div>
                <v-text-field 
                  v-else
                  required
                  placeholder="Enter category name"
                  v-model="category.category"
                  @blur="updateCategory({ 
                    categoryId: category.id, 
                    data: { category: category.category }
                  })"/>

                <div class="buttons">
                  <button 
                    @click="toggleEdit(category.id)"
                    class="button is-small">
                    <span class="icon">
                      <i class="fas fa-edit has-text-grey"></i>
                    </span>
                  </button>
                  <button 
                    @click="deleteCategory(category.id)"
                    class="button is-small">
                    <span class="icon">
                      <i class="fas fa-trash has-text-grey"></i>
                    </span>
                  </button>
                </div>

              </div>
            </a>
          </div>

          <!-- adding new category -->
          <div v-if="addingCategory">
            <v-form :valid.sync="valid" class="pb-2">
              <v-text-field 
                required
                placeholder="Enter category name"
                v-model="category"/>
            </v-form>

            <div class="buttons">
              <button 
                :disabled="!valid"
                @click="addNewCategory()"
                class="button is-primary is-small">
                <span class="icon">
                  <i class="fas fa-save"></i>
                </span>
                <span>Save new Category</span>
              </button>
              <button 
                @click="addingCategory = false"
                class="button is-small">
                <span class="icon">
                  <i class="fas fa-times has-text-grey"></i>
                </span>
                <span>Exit Add Category</span>
              </button>
            </div>
          </div>

          <button 
            v-if="!addingCategory"
            class="button is-primary is-small" 
            @click="addingCategory = true; editingCategoryId = null">
            Add a Category
          </button>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { VTextField, VForm },
  data() {
    return {
      valid: false,
      category: null,
      addingCategory: false,
      editingCategoryId: null
    }
  },
  computed: {
    ...mapState("tickets", ["categories"])
  },
  methods: {
    ...mapActions("tickets", [
      "addCategory", "updateCategory", "deleteCategory"
    ]),
    addNewCategory() {
      this.addCategory({ category: this.category })
        .then(() => {
          this.category = null;
          this.addingCategory = false;
        });
    },
    toggleEdit(categoryId) {
      if (this.editingCategoryId == categoryId) {
        this.editingCategoryId = null;
      } else {
        this.editingCategoryId = categoryId;
      }
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
.row-justified {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
}

.modal-card {
  border-radius: 6px;
}
</style>